import { FC, ReactNode } from 'react'
import { AntTooltip, Text, TextColor } from '@agro-club/agroclub-shared'
import useFormatDate from 'hooks/useFormatDate'
import { RailwayRoute, RangeType, RateType } from '../types'
import { useTranslation } from 'react-i18next'
import { DASH } from 'modules/constants'

interface Prop {
  logistics_rates?: RateType[]
  range?: RangeType
  rate?: RailwayRoute
}

export const RateCell: FC<Prop> = ({ logistics_rates, range, rate: extRate }) => {
  const { t } = useTranslation('rates')
  const formatDate = useFormatDate()
  let rate: RailwayRoute | RateType | undefined
  if (extRate) {
    rate = extRate
  } else if (logistics_rates && range) {
    rate = logistics_rates.find(
      (rate) => rate.distance_range.lower === range.lower && rate.distance_range.upper === range.upper,
    )
  }

  if (!rate) return DASH
  let historyInfo: ReactNode = t('noHistoryInfo')
  let wasCellColor: string | undefined
  let nowCellColor: string | undefined
  if (rate.history_info) {
    if ((rate.rate || 0) > (rate.history_info.rate || 0)) {
      wasCellColor = 'approve'
      nowCellColor = 'accentDestruct600'
    } else if ((rate.rate || 0) < (rate.history_info.rate || 0)) {
      wasCellColor = 'accentDestruct600'
      nowCellColor = 'approve'
    }
    historyInfo = (
      <div>
        <div style={{ marginBottom: 10 }}>
          <Text typography="accentSmall">
            {rate.history_info.modified_by ? rate.history_info.modified_by.full_name : t('created')}
          </Text>
          <Text typography="bodySmall">{formatDate(rate.history_info.modified, { withTime: true })}</Text>
        </div>
        <div>
          <Text as="span" typography="bodySmall">
            {' '}
            {t('was')}:
          </Text>{' '}
          <Text as="span" typography="bodyMedium" color={wasCellColor as TextColor}>
            {rate.history_info.rate}
            {'rate_with_overload' in rate.history_info && ` / ${rate.history_info.rate_with_overload}`}
          </Text>
        </div>
        <div>
          <Text as="span" typography="accentSmall">
            {' '}
            {t('is')}:
          </Text>{' '}
          <Text as="span" typography="bodyMedium" color={nowCellColor as TextColor}>
            {rate.rate}
            {'rate_with_overload' in rate && ` / ${rate.rate_with_overload}`}
          </Text>
        </div>
      </div>
    )
  }

  return (
    <AntTooltip tooltipContent={historyInfo} variant="secondary">
      <div>
        <div>{rate.rate}</div>
        {'rate_with_overload' in rate && <div>{rate.rate_with_overload}</div>}
      </div>
    </AntTooltip>
  )
}
